<template>

<form class="mx-auto col-sm-12" @submit.prevent>

    <div class="row">
        <div class="form-group col-lg-6">
            <label for="active_type">{{ $t('active_type') }}</label>
            <Combobox
                class="bg-white"
                name='active_type'
                :placeholder="$t('select_a_item')"
                :hasErrors="errors.has('active_type')"
                :options="activestype"
                label="name"
                :initial-value="activeMovement.activeType"
                v-model="activeMovement.activeType"
                :reduce="activeType => activeType.id"
                v-validate="'required'"
            />

            <small v-show="errors.has('active_type')" class="form-text text-muted">
                {{ errors.first('active_type') }}
            </small>
        </div>

        <div class="form-group col-lg-6">
            <label for="serial">{{ $t('serial') }}</label>
            <Combobox
                :disabled="!activeMovement.activeType"
                class="bg-white"
                name='serial'
                :placeholder="$t('select_a_item')"
                :hasErrors="errors.has('serial')"
                :options="serials"
                label="serie"
                :initial-value="activeMovement.serial"
                v-model="activeMovement.serial"
                :reduce="serial => serial.serie"
                v-validate="'required'"
            />

            <small v-show="errors.has('serial')" class="form-text text-muted">
                {{ errors.first('serial') }}
            </small>
        </div>
    </div>

    <div class="row">
        <div class="form-group col-lg-6" :class="{ 'has-error': errors.has('movement_type') }">
            <label for="movement_type">{{ $t('movement_type') }}</label>
            <Combobox
                :disabled="!activeMovement.activeType"
                class="bg-white"
                name='movement_type'
                :placeholder="$t('select_a_item')"
                :hasErrors="errors.has('movement_type')"
                :options="movementTypesFiltered"
                label="name"
                :initial-value="activeMovement.movementType"
                v-model="activeMovement.movementType"
                :reduce="movementType => movementType.id"
                v-validate="'required'"
            />

            <small v-show="errors.has('movement_type')" class="form-text text-muted">
                {{ errors.first('movement_type') }}
            </small>
        </div>

        <div class="form-group col-lg-6" :class="{ 'has-error': errors.has('coast') }">
            <label for="coast">{{ $t('coast') }}</label>
            <CurrencyInput
                :placeholder="$t('ph_coast')"
                v-model="activeMovement.coast"
                :auto-decimal-mode="true"
                :distraction-free='false'
                currency='BRL'
                locale='pt-BR'
                class="demo__currency-input form-control"
            />

            <small v-show="errors.has('coast')" class="form-text text-muted">
                {{ errors.first('coast') }}
            </small>
        </div>
    </div>

    <LoaderButton
        @click="onClick"
    >
        {{ $t('save') }}
    </LoaderButton>
</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import { request } from '@/lib/http'

export default {
    name: 'ActiveMovementForm',
    components: {
        LoaderButton,
        Combobox
    },

    data() {
        return {
            serials: [],
            movementTypesFiltered: []
        }
    },

    props: {
        activeMovement: {
            type: Object,
            default: () => ({
                activeType: undefined,
                serial: undefined,
                movementType: undefined,
                coast: undefined
            })
        }
    },

    computed: {
        ...mapState({
            activestype: state => state.activestype.all,
            movementTypes: state => state.movementtype.all,
        })
    },

    watch: {
        'activeMovement.activeType': async function(value) {
            if (!value) {
                this.activeMovement.movementType = undefined
                return this.activeMovement.serial = undefined
            }

            this.$store.dispatch('overlay/show', true)

            this.activeMovement.movementType = undefined
            this.activeMovement.serial = undefined

            this.serials = await request({
                url: 'list-serials',
                method: 'get',
                params: { activeType: value }
            })

            this.movementTypesFiltered = this.movementTypes.filter(movementType => movementType.activeType.id === value)
            this.$store.dispatch('overlay/show', false)
        }
    },

    methods: {
        async onClick (evt, done) {
            const valid = await this.$validator.validateAll()
            if (!valid) {
                const err = new Error(this.$t('invalid_form_fields'))
                this.$store.dispatch('notify/error', err)
                return
            }
            
            const result = await request({
                url: 'save-history-active',
                method: 'post',
                data: this.activeMovement
            })
            
            if (result) {
                this.$router.push({ name: 'listactivemovement' })
            }
        }
    },

    async mounted () {
        const { dispatch } = this.$store

        await dispatch('activestype/fetchAll')
        await dispatch('movementtype/fetchAll')
    },

    destroyed () {
        const { dispatch } = this.$store

        dispatch('activestype/cleanState')
        dispatch('movementtype/cleanState')
    }
}
</script>